module.exports = __webpack_public_path__ + "static/media/EndOfRunReport.604a8a49.png";